import { api } from "@/shared/api";

export type GeoEntryReason = "NOT_CONFIGURED" | "NO_ACCOUNT" | "ERROR";

export interface GeoEntryResponse {
  available: boolean;
  url: string | null;
  reason: GeoEntryReason | null;
}

export const GEO_ENTRY_REASON_TEXT: Record<GeoEntryReason, string> = {
  NOT_CONFIGURED: "GEO 管理系统暂未开通,请联系平台管理员",
  NO_ACCOUNT: "当前租户暂无 GEO 管理系统权限。若已购买该服务,请联系对接人确认开通状态",
  ERROR: "暂时进不去 GEO 管理系统,请稍后重试",
};

export const geoEntryService = {
  entry: () => api.get<GeoEntryResponse>("/me/external/geo-entry"),
};
